/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserStats } from '../fn/user-stats/get-user-stats';
import { GetUserStats$Params } from '../fn/user-stats/get-user-stats';
import { UserStatsDto } from '../models/user-stats-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserStatsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserStats()` */
  static readonly GetUserStatsPath = '/api/user-stats/{userId}';

  /**
   * Gets statistics about a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserStats$Response(params: GetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatsDto>> {
    return getUserStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets statistics about a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserStats(params: GetUserStats$Params, context?: HttpContext): Observable<UserStatsDto> {
    return this.getUserStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserStatsDto>): UserStatsDto => r.body)
    );
  }

}
